var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import React from 'react';
import { action, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';

import ContentEditable from 'react-contenteditable';
import { Editor } from '../Editor';

import './ContentEditable.scss';

export var TextCellEditor = function TextCellEditor(_ref) {
  var cell = _ref.cell,
      update = _ref.update;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var _extends2;

        var field = cell.column.id;
        var value = e.target.textContent;
        update(_extends({}, cell.original, (_extends2 = {}, _extends2[field] = value, _extends2)));
      }
    },
    cell.value
  );
};

export var TextFieldEditor = (_dec = inject('store', 'spacesStore'), _dec(_class = observer(_class = (_class2 = function (_React$Component) {
  _inherits(TextFieldEditor, _React$Component);

  function TextFieldEditor() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextFieldEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initDefineProp(_this, 'value', _descriptor, _this), _this.currentValue = function () {
      return _this.props.store.selected[_this.props.field] || _this.props.defaultValue;
    }, _this.handleFocus = function (e) {
      _this.setValue(_this.currentValue());
      _this.disposer = reaction(function () {
        return _this.value;
      }, function (value) {
        if (_this.currentValue() !== value) _this.update(value);
      }, {
        delay: 1500
      });
    }, _this.handleChange = function (e) {
      _this.setValue(e.target.value);
    }, _this.handleBlur = function (e) {
      _this.disposer();
      if (_this.currentValue() !== _this.value) _this.update(_this.value);
    }, _this.update = function (value) {
      _this.props.store.updateField(_this.props.field, value ? value.trim() : value);
    }, _initDefineProp(_this, 'setValue', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextFieldEditor.prototype.render = function render() {
    return React.createElement(ContentEditable, { className: 'content-editable',
      html: (this.props.store.selected || {})[this.props.field] || '',
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      onBlur: this.handleBlur
    });
  };

  return TextFieldEditor;
}(React.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'setValue', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (value) {
      _this2.value = value;
    };
  }
})), _class2)) || _class) || _class);

export var TextValueEditor = inject('store', 'spacesStore')(observer(function (_ref2) {
  var store = _ref2.store,
      field = _ref2.field,
      locale = _ref2.locale,
      _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? '' : _ref2$className,
      spacesStore = _ref2.spacesStore;

  var values = store._sending.values || {};
  var currentValue = field.localize && locale !== undefined ? (values[field.key] || {})[locale.key] || '' : values[field.key] || '';
  if (typeof currentValue !== 'string') {
    var defaultLocale = ((spacesStore.selected || {}).locales || [{}])[0];
    if ((typeof currentValue === 'undefined' ? 'undefined' : _typeof(currentValue)) === 'object' && defaultLocale && defaultLocale.key && currentValue[defaultLocale.key]) currentValue = currentValue[defaultLocale.key];else currentValue = JSON.stringify(currentValue);
  }
  return React.createElement(ContentEditable, { className: 'content-editable ' + className,
    html: currentValue,
    onFocus: store.selectField(field, locale),
    onChange: store.updateEntryField(field, locale),
    onBlur: store.updateEntryField(field, locale, true)
  });
}));